import React, { useState } from 'react';
import logo from '../../assets/images/logo-trans.png';
import { SidebarData } from '../../data/index';
import CustomLink from '../shared/custom-link';
import { useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { CollapseIcon } from '../../svgs/index';

const RenderMenuItem = ({ item, pathName, openDropdowns, toggleDropdown, level = 0, collapsed }) => {
    const isActive = pathName.startsWith(item.src);
    const isSubActive = item.subItems?.some(
        (subItem) =>
            pathName.startsWith(subItem.src) ||
            subItem.subItems?.some((nestedItem) => pathName.startsWith(nestedItem.src))
    );
    const isOpen = openDropdowns[item.name];

    return (
        <div className={collapsed && level === 0 ? 'flex justify-center' : ''}>
            {/* Menu Item */}
            <div
                className={`flex items-center  text-dark gap-2 rounded-lg cursor-pointer
        ${isActive || isSubActive ? 'bg-activeGray font-semibold' : 'hover:bg-activeGray font-medium bg-transparent'}
        ${collapsed && level === 0 ? 'justify-center' : ''}`}
                style={level > 0 ? { marginLeft: `${level * 22}px` } : {}}
                onClick={() => !collapsed && item.subItems && toggleDropdown(item.name)}
            >

                <CustomLink
                    to={item.src || '#'}
                    className={`flex items-center py-2 px-3 gap-2 ${collapsed && level === 0 ? 'justify-center' : 'w-full'}`}
                >

                    {item.icon && (
                        <item.icon className={`flex-shrink-0 ${collapsed && level === 0 ? 'h-6 w-6' : 'h-5 w-5'}`} />
                    )}
                    {!collapsed && (
                        <span className='text-sm flex items-center gap-1'>
                            {level > 0 && <span className="text-sm leading-none">•</span>}
                            {item.name}
                        </span>
                    )}

                    {!collapsed && item.subItems && (
                        <ChevronDown className={`text-gray-700 h-5 w-5 flex-shrink-0 transition-all ${isOpen ? 'rotate-180' : ''}`} />
                    )}
                </CustomLink>
            </div>

            {/* Sub-items (Dropdown) */}
            {!collapsed && item.subItems && isOpen && (
                <div className={`flex flex-col gap-1 mt-1`}>
                    {item.subItems.map((subItem, subIndex) => (
                        <RenderMenuItem
                            key={subIndex}
                            item={subItem}
                            pathName={pathName}
                            openDropdowns={openDropdowns}
                            toggleDropdown={toggleDropdown}
                            level={level + 1}
                            collapsed={collapsed}
                        />
                    ))}
                </div>
            )}

        </div>
    );
};

const Sidebar = ({ collapsed, toggleCollapse }) => {
    const location = useLocation();
    const pathName = location.pathname;
    const [openDropdowns, setOpenDropdowns] = useState({});

    const toggleDropdown = (name) => {
        setOpenDropdowns((prev) => ({
            ...prev,
            [name]: !prev[name],
        }));
    };

    return (
        <div className={`flex flex-col w-full justify-between h-screen border-r border-border custom-scrollbar overflow-auto overflow-x-hidden bg-lightGray py-3 transition-all duration-300 ease-in-out ${collapsed ? 'items-center' : ''}`}>
            <div className="flex flex-col gap-4 px-2">
                {/* Logo or Collapse Icon */}
                <div className="flex justify-center px-2">
                    {collapsed ? (
                        <button onClick={toggleCollapse} className="p-2">
                            <CollapseIcon className="h-7 w-7 " />
                        </button>
                    ) : (
                        <div className='flex items-center flex-col gap-2'>
                            <CustomLink to="/dashboard" className="flex justify-start">
                                <img src={logo} alt="Logo" className=" h-8" />
                            </CustomLink>
                            <p className='text-sm font-medium text-gray-700 text-center'>Fleet management solution</p>
                        </div>
                    )}
                </div>

                {/* Menu Items */}
                <div className="flex flex-col gap-0.5">
                    {SidebarData.map((item, index) => (
                        <RenderMenuItem
                            key={index}
                            item={item}
                            pathName={pathName}
                            openDropdowns={openDropdowns}
                            toggleDropdown={toggleDropdown}
                            level={0}
                            collapsed={collapsed}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Sidebar;